import Environment from '../models/environment'
import Backbone from '@polleverywhere/backbone'
import _ from 'underscore'
import URI from 'urijs'

const env = new Environment()

/**
 * Re-writes requests to the api_url through a proxy running on the current
 * domain (i.e. window.location). However, this class also contains most of the
 * ajaxPrefilter logic that existed prior to AjaxChain. Eventually those other
 * features should be extracted into their own classes.
 *
 * Other features include:
 * - Defaulting relative URLs to point to api_url.
 * - Flash options hack to record the type of the request on the model.
 */
export default class Proxy {
  constructor (cache, nextAjax) {
    this.ajax = this.ajax.bind(this)
    this.nextAjax = nextAjax
  }

  ajax (options) {
    /*
     * Don't touch firehose requests
     * JSONP requests don't need this either
     * Only process if proxy is enabled
     */
    if (options.firehose || options.dataType === 'script' ||
      options.dataType === 'jsonp' || !env.get('proxy_enabled')) {
      return this.nextAjax(options)
    }

    options = _.defaults(options, {
      xhrFields: {}
    })

    /*
     * Hack!
     * The `sync` event in Backbone doesn't expose the request type. (facepalm)
     * The short poller in Viz needs to know the last request
     * method so that it can skip a fetch cycle after a POST request
     * since it will already have the latest state. Otherwise, there
     * will be a flicker where the old results will render because
     * the json from the server will be cached
     */
    if (options.model) {
      options.model._lastRequestMethod = options.type
    }

    /*
     * Only set this up if we're given a relative path. Paths with domains
     * should just flow through to the next uri mutations.
     */
    const url = URI(options.url).absoluteTo(env.get('api_url'))
    options.url = url.toString()

    // Check if this is a cross domain request.
    if (url.host() === env.get('api_url').host()) {
      /*
       * We are always crossDomain because you should never set
       * nginx_proxy_path when running JS code on the api_url.
       */
      options.crossDomain = true
      // We need this for CORS + Cookies to work when using jQuery
      if (typeof options.xhrFields.withCredentials !== 'boolean') {
        options.xhrFields.withCredentials = true
      }

      if (env.get('nginx_proxy_path')) {
        nginxProxy(options, env.get('nginx_proxy_path'))
      } else if (!Backbone.$.support.cors) {
        console.warn("Detected '$.support.cors = false', but no proxy is available. Cross-domain XHR requests may not work. You are likely running an unsupported browser. Try upgrading your browser. On iOS, try upgrading your Operating System.")
      }
    }

    return this.nextAjax(options)
  }
}

/*
 * Cross Domain polyfill for pollev.com`
 * ---
 * IMPORTANT: We MUST call toString() on this method or IE will barf on allow
 * other URLS to access the domain. For example, IE would request the URL
 * 'multiple_choice_polls/[object]' without throwing an error message.
 */
function nginxProxy (options, proxyPath) {
  options.crossDomain = false
  const url = URI(options.url)
  url.resource(proxyPath + url.resource())
  url.origin(URI().origin())
  options.url = url.toString()
  return options.url
}
